import React, { useState, useEffect } from "react";
import { Nav } from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from "axios";
import { SERVER_PATH } from "../../config/env";
import Logo from "../../assets/img/logo.png";
import {
  AiOutlineSearch,
  AiOutlineShoppingCart,
  AiOutlineUser,
} from "react-icons/ai";

export default function Mobile() {
  let [menuBar, setMenuBar] = useState("collapse");
  const [navMap, setNavMap] = useState({});
  const [pathMap, setPathMap] = useState({});

  useEffect(() => {
    axios
      .get(`${SERVER_PATH}get/navbar.php?t=${Date.now()}`)
      .then((res) => {
        if (res.data) {
          if (res.data.key_map) setNavMap(res.data.key_map);
          if (res.data.path_map) setPathMap(res.data.path_map);
        }
      })
      .catch((err) => {});
  }, []);

  const toggleMenu = () => {
    setMenuBar(menuBar === "collapse show" ? "collapse" : menuBar);
  };
  return (
    <>
      <Nav
        className="navbar navbar-expand-lg navbar-light shadow d-lg-none"
        style={{
          backgroundColor: "var(--navbar)",
          position: "sticky",
          top: 0,
          zIndex: 3,
        }}>
        <div className="container d-flex justify-content-between align-items-center" >
          <Link
            className="logo align-self-center text-decoration-none"
            to={pathMap.home || "/"}
            style={{ width: "auto" }}>
            <div
              style={{
                backgroundColor: "#FFFFFF",
                padding: "6px 16px",
                borderRadius: "8px",
                display: "inline-block",
                boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
              }}>
              <img src={Logo} alt="sivam farms logo" height="auto" style={{ maxWidth: "190px", maxHeight: "55px", width: "100%", objectFit: "contain", display: "block" }} />
            </div>
          </Link>

          <button
            className="navbar-toggler border-0"
            type="button"
            onClick={() => {
              toggleMenu();
            }}
            data-bs-toggle={menuBar}
            data-bs-target="#templatemo_main_nav"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>

          <div
            className="align-self-center collapse navbar-collapse flex-fill  d-lg-flex justify-content-lg-between"
            id="templatemo_main_nav">
            <div className="flex-fill">
              <ul className="nav navbar-nav d-flex justify-content-between mx-lg-auto">
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to={pathMap.home || "/"}
                    onClick={() => toggleMenu()}>
                    {navMap.home || "Home"}
                  </Link>
                </li>

                <li className="nav-item">
                  <Link className="nav-link" to={pathMap.herbal || "/herbalProduct"}>
                    {navMap.herbal || "Herbal Products"}
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to={pathMap.wellness || "/yoga"}>
                    {navMap.wellness || "Health And Wellness"}
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to={pathMap.about || "/about"}>
                    {navMap.about || "About"}
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to={pathMap.gallery || "/gallery"}>
                    {navMap.gallery || "Gallery"}
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to={pathMap.tracker || "/tracker"}>
                    {navMap.tracker || "Tracker"}
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to={pathMap.unique || "/uniqueProducts"}>
                    {navMap.unique || "Unique Products"}
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    to="/cart"
                    className="nav-icon position-relative text-decoration-none">
                    <AiOutlineShoppingCart style={{ fontSize: "1.7em" }} />
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    to="/profile"
                    className="nav-icon position-relative text-decoration-none">
                    <AiOutlineUser style={{ fontSize: "1.7em" }} />
                  </Link>
                </li>
              </ul>
            </div>
           
          </div>
        </div>
      </Nav>
    </>
  );
}
